export const setAsDefault = async (customerRef: string, remoteCardRef: string): Promise<void> => {
  window.showNotifier('working');

  try {
    const response = await fetch(`/admin/customers/${customerRef}/cards/${remoteCardRef}`, {
      method: 'PATCH',
    });

    window.hideNotifier('working');

    if (response.ok) {
      window.flashNotifier('success', 'Set as default card', 3);
    } else {
      window.alertUser('Unable to set card as default. Try again');
      throw new Error('Failed to set card as default');
    }
  } catch (error) {
    window.hideNotifier('working');
    window.alertUser('Unable to set card as default. Try again');
    throw error;
  }
};

export class NicknameValidationError extends Error {
  validationError = true;

  constructor(message: string) {
    super(message);
    this.name = 'NicknameValidationError';
  }
}

export const updateNickname = async (
  customerRef: string,
  remoteCardRef: string,
  nickname: string | null
): Promise<void> => {
  window.showNotifier('working');

  try {
    const response = await fetch(
      `/admin/customers/${customerRef}/cards/${remoteCardRef}/nickname`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nickname }),
      }
    );

    window.hideNotifier('working');

    if (response.ok) {
      window.flashNotifier('success', 'Nickname saved', 3);
    } else if (response.status === 422) {
      let message = 'Invalid nickname.';
      try {
        const body = await response.json();
        if (typeof body === 'string' && body.length > 0) {
          message = body;
        }
      } catch {
        // use default message
      }
      throw new NicknameValidationError(message);
    } else {
      window.alertUser('Unable to save nickname. Try again');
      throw new Error('Failed to update nickname');
    }
  } catch (error) {
    window.hideNotifier('working');
    if (error instanceof NicknameValidationError) {
      throw error;
    }
    window.alertUser('Unable to save nickname. Try again');
    throw error;
  }
};

export const removeNickname = async (customerRef: string, remoteCardRef: string): Promise<void> => {
  window.showNotifier('working');

  try {
    const response = await fetch(
      `/admin/customers/${customerRef}/cards/${remoteCardRef}/nickname`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nickname: null }),
      }
    );

    window.hideNotifier('working');

    if (response.ok) {
      window.flashNotifier('success', 'Nickname removed', 3);
    } else {
      window.alertUser('Unable to remove nickname. Try again');
      throw new Error('Failed to remove nickname');
    }
  } catch (error) {
    window.hideNotifier('working');
    window.alertUser('Unable to remove nickname. Try again');
    throw error;
  }
};

export const fetchNicknames = async (): Promise<string[]> => {
  try {
    const response = await fetch('/admin/cards/nicknames');
    if (!response.ok) return [];
    const data = await response.json();
    return data.nicknames ?? [];
  } catch {
    return [];
  }
};

export const removeCard = async (customerRef: string, remoteCardRef: string): Promise<void> => {
  try {
    const response = await fetch(`/admin/customers/${customerRef}/cards/${remoteCardRef}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      window.alertUser('Unable to delete saved card. Try again');
      throw new Error('Failed to delete card');
    }
  } catch (error) {
    window.alertUser('Unable to delete saved card. Try again');
    throw error;
  }
};
